import * as Yup from "yup";

import { AppShape } from "@eave/shared/types/api";

import { AppDelta } from "./shared";
import { borrowersAscending } from "@eave/shared/utils/borrowers";

const dependentsListOfAgesSchema = Yup.string()
  .nullable()
  .test({
    name: "dependents",
    test: (value: undefined | string) => {
      if (!value) {
        return true;
      }
      return value.split(",").every(age => age.trim().match(/^\d+$/));
    },
    message: "must be empty or a comma-separated list of ages",
  });

export const validationSchemaFromLoanApp = (app: AppShape) => {
  const schema: any = {};

  borrowersAscending(app.borrowers).forEach(
    borrower =>
      (schema[`borrower${borrower.borrower_entity}_dependents_list_of_ages`] =
        dependentsListOfAgesSchema),
  );

  return Yup.object().shape(schema);
};

export const initialValuesFromLoanApp = (app: AppShape): AppDelta => {
  const { borrowers } = app;

  const values: AppDelta = {};
  borrowersAscending(borrowers).forEach(
    borrower =>
      (values[`borrower${borrower.borrower_entity}_dependents_list_of_ages`] =
        borrower.dependents_list_of_ages),
  );

  return values;
};
